<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">Register Device</h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
@if (displayName !== '') {
  <div class="modal-body">
    <img
      id="imgSecurityKey"
		src="assets/images/securitykey.svg
		 "
      />
      <br />
      <h2>Registering...</h2>
      <p>Tap your security key to continue registering your device...</p>
    </div>
  }
  @if (displayName === '') {
    <div class="modal-body">
      <p>Please enter a friendly display name for your security device.</p>
      <label for="txtDisplayName" class="required-field for">Display Name</label>
      <input
        (keyup.enter)="registerCredential()"
        [(ngModel)]="displayNameVal"
        id="txtDisplayName"
        required
        type="text"
        class="form-control"
        />
        <br />
        <label for="txtPassword" class="required-field for">Verify Password</label>
        <input
          (keyup.enter)="registerCredential()"
          [(ngModel)]="password"
          required
          id="txtPassword"
          type="password"
          class="form-control"
          />
        </div>
      }
      <div class="modal-footer">
        <button class="btn btn-cancel btn-lg" (click)="activeModal.dismiss()">Cancel</button>
        @if (displayName === '') {
          <button
            [disabled]="!validateForm()"
            (click)="registerCredential()"
            type="submit"
            class="btn btn-save btn-lg"
            >
            Set Name
          </button>
        }
      </div>
